/**
 * Canned, dev-friendly price strings for the real product IDs
 * (`packages/economy/src/iap-catalog.ts`'s `IAP_PRODUCT_IDS` for Android,
 * `WEB_IAP_PRODUCT_IDS` for RevenueCat Web Billing) — placeholders only, no real store
 * pricing round-trip exists yet. Not imported from `@puzzlemania/economy` directly to
 * avoid a providers -> economy dependency (providers sit below economy in the
 * layering); the IDs are duplicated here deliberately, same as every other
 * Mock/real-provider pairing in this codebase.
 */
const MOCK_PRICE_STRINGS = {
    'puzzlemaniastudio.puzzlemania.itemsort.gems_pack_2': '$0.99',
    'puzzlemaniastudio.puzzlemania.itemsort.gems_pack_3': '$4.99',
    'puzzlemaniastudio.puzzlemania.itemsort.gems_pack_4': '$9.99',
    web_small_pack: '$0.99',
    web_medium_pack: '$4.99',
    web_large_pack: '$9.99',
};
export class MockPurchaseProvider {
    async getProducts(productIds) {
        return productIds.map((productId) => ({
            productId,
            priceString: MOCK_PRICE_STRINGS[productId] ?? '$0.99',
        }));
    }
    async purchase(productId) {
        return { productId, transactionId: `mock-txn-${crypto.randomUUID()}` };
    }
}
